module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/joanna-rodak-6f34819684ff4aac24b127dbc10c14ea.png";